import { MdLeaderboard } from "react-icons/md";
import { Button } from "@/components/ui/button/button";
import { Link } from "react-router-dom";

export const HomeMyLeadsCard = () => {
  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-4">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">My Leads</h2>

        <MdLeaderboard className="w-4 h-4" />
      </div>
      <div className="">
        <Button variant="default" asChild size="sm" className="">
          <Link to="/employee/leads">View</Link>
        </Button>
      </div>
    </div>
  );
};
